import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 10.031 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 10.031 15\" id=\"location\"><path d=\"M8.562 1.539C7.614.546 6.354 0 5.014 0c-1.34 0-2.6.546-3.548 1.539C-.288 3.375-.506 6.829.994 8.922L5.014 15l4.014-6.07c1.506-2.101 1.288-5.555-.466-7.391ZM5.06 7.122c-1.009 0-1.831-.86-1.831-1.917s.822-1.918 1.831-1.918c1.01 0 1.832.861 1.832 1.918S6.07 7.122 5.06 7.122Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol